export const UPDATE_USER_UID = 'UPDATE_USER_UID'

export function userUidReducer (state = null, action) {
    switch (action.type){
        case UPDATE_USER_UID:
            return action.payload
        default: return state
    }
}